import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/perfil')({
  component: lazyRouteComponent(
    () => import('@/features/profile/components/profile-page'),
    'ProfilePage'
  ),
})
